import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import MiniLoader from "components/MiniLoader";
import { CSVLink, CSVDownload } from "react-csv";
import { EntryModal, PositionHeatmapModal, Row } from './components';
import { connect } from "react-redux";
import * as actions from "redux/actions/stockOrderActions";
import * as quoteActions from "redux/actions/quoteActions";
import useStockQuotes from "hooks/useStockQuotes";
import { Translate, I18n } from "react-redux-i18n";
import axios from "axios";
import { config } from "config";
import { getApiHeaders } from "api/apiHeaders";

const FEAR_GREED_RATING_KEYS = {
  extreme_fear: 'fear_greed_extreme_fear',
  fear: 'fear_greed_fear',
  neutral: 'fear_greed_neutral',
  greed: 'fear_greed_greed',
  extreme_greed: 'fear_greed_extreme_greed',
};

function fearGreedTone(rating) {
  switch (rating) {
    case 'extreme_fear':
      return 'extreme-fear';
    case 'fear':
      return 'fear';
    case 'neutral':
      return 'neutral';
    case 'greed':
      return 'greed';
    case 'extreme_greed':
      return 'extreme-greed';
    default:
      return 'neutral';
  }
}

function formatSentimentChange(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  const abs = Math.abs(n).toFixed(0);
  if (n > 0) return `+${abs}`;
  if (n < 0) return `-${abs}`;
  return abs;
}

const useStyles = {
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    // marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  },

};

const stylesLocal = {
  subcell: {
    padding: "5px"
  },
  cell: {
    padding: "8px"
  }
};


function getCapital(rows) {
  var cap = 0;
  var count = 0;
  rows.map(item => {
    if (item.counter === 1) {
      cap = cap + Math.abs(item.open_trade);
      count++;
    }

    else {
      item.sub_order.map(item_ => {
        cap = cap + Math.abs(item_.open_trade);
        count++;
      });
    }
  });

  return "Position " + count + " = $" + Number(cap).toFixed(2) + " USD";
}

const StockOrders = props => {
  const { className, ...rest } = props;

  const [list, setList] = useState(props.list);
  const [heatmapOpen, setHeatmapOpen] = useState(false);
  const [sentiment, setSentiment] = useState(null);
  //const [cap, setCap] = useState(0.0);
  const headers = [
    { label: "Symbol", key: "symbol" },
    { label: "Last", key: "last" },
    { label: "Qtt", key: "quantity" },
    { label: "Open Prc", key: "open_price" },
    { label: "Open Trd", key: "open_trade" },
    { label: "P/L", key: "pl" },
    { label: "P/L%", key: "pl" },
    { label: "Open Date", key: "open_at" },
  ];

  const dataCsv = () => {
    let data = [];
    props.list.forEach(element => {
      let item = {};
      headers.forEach(ref => {
        item = {
          ...item,
          [ref.key]: element[ref.key]
        };
      });
      data = data.concat(item);
    });
    return data;
  }

  useEffect(() => {
    if (props.list.length === 0)
      props.loadList(props.user_id, props.token);
  }, []);

  useEffect(() => {
    if (!props.user_id) {
      return undefined;
    }

    let cancelled = false;
    const refreshSentiment = async () => {
      try {
        const response = await axios.get(`${config.api.web}market/fear-greed`, {
          headers: getApiHeaders(),
        });
        if (cancelled) {
          return;
        }
        if (response.status < 300 && response.data?.status === 'Success') {
          setSentiment(response.data.body || null);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('loadFearGreed', error.response?.data?.body || error.message);
        }
      }
    };

    refreshSentiment();
    const interval = setInterval(refreshSentiment, 15 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [props.user_id]);

  useStockQuotes(props.list, props.user_id, props.token, props.loadStockQuotes);

  const sentimentScore = Number(sentiment?.score);
  const sentimentRating = sentiment?.rating || 'neutral';
  const sentimentTone = fearGreedTone(sentimentRating);
  const sentimentLabelKey = FEAR_GREED_RATING_KEYS[sentimentRating] || FEAR_GREED_RATING_KEYS.neutral;
  const sentimentChangeLabel = formatSentimentChange(sentiment?.change);
  const hasSentiment = Number.isFinite(sentimentScore) && sentimentScore >= 0;

  return (
    <div className=''>
      <div className="portfolio-toolbar">
                <span className="portfolio-summary">
                {getCapital(props.list || [])}
                </span>
                 <div className="portfolio-toolbar-actions">
                  {hasSentiment && (
                    <span
                      className={`portfolio-sentiment is-${sentimentTone}`}
                      title={I18n.t('fear_greed_subtitle')}
                    >
                      <span className="portfolio-sentiment-level">
                        <Translate value={sentimentLabelKey} />
                      </span>
                      <span className="portfolio-sentiment-label">
                        <Translate value="fear_greed_title" />
                      </span>
                      <span className="portfolio-sentiment-value">{sentimentScore}</span>
                      {sentimentChangeLabel && (
                        <span className="portfolio-sentiment-change">{sentimentChangeLabel}</span>
                      )}
                    </span>
                  )}
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setHeatmapOpen(true)}
                    disabled={!props.list?.length}
                  >
                    <Translate value="portfolio_heatmap" />
                  </button>
                  <EntryModal />
                </div>
              </div>
      <PositionHeatmapModal
        open={heatmapOpen}
        list={props.list}
        stock={props.stock}
        onClose={() => setHeatmapOpen(false)}
      />
      <div className='divider' />
      <div className={''}>
            <table className="table table-hover portfolio-sticky-table">
              <thead>
                <tr>
                  <th align="left">
                    <span className="tooltip">
                      Symbol
                      <span className="tooltiptext">Sort</span>
                    </span>
                  </th>
                  <th align="right">Last</th>
                  <th align="right">Qtt</th>
                  <th align="right">OpnPrc</th>
                  <th align="right">OpnTrd</th>
                  <th align="right">NetLiq</th>
                  <th align="right">P/L</th>
                  <th align="right">P/L%</th>
                  <th align="center">OpnDate</th>
                  <th align="left">Reference</th>
                  <th>Act</th>
                </tr>
              </thead>
              <tbody>
                {
                  props.list.map((order, index) => (
                    <Row key={index} order={order} />
                  ))
                }
              </tbody>
            </table>
      </div>
      <div className='divider' />

      {
        props.loading ? (
          <div className='card-actions' style={{ "justifyContent": "center", }}>
            <MiniLoader />
          </div>
        ) : <div className={'useStyles.actions'}>
              <CSVLink
                data={dataCsv()}
                separator={";"}
                headers={headers}
                className="btn btn-primary"
                filename={"Ebi_stock_" + new Date().getTime() + ".csv"}
              > <Translate value="download" /> CSV
              </CSVLink>
            </div>
      }
    </div>
  );
};

StockOrders.propTypes = {
  className: PropTypes.string
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {

    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    list: reducer.stockOrder.list,
    error: reducer.stockOrder.error,
    loading: reducer.stockOrder.loading,
    stock: reducer.event.stock,
  };
}
const mapDispatchToProps = dispatch => ({
  loadList: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
  loadStockQuotes: (symbols, user_id, token) =>
    dispatch(quoteActions.loadStockQuotes({ symbols, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(StockOrders);
/**
 * enclosingCharacter={`'`}
 *  target="_blank"
 * filename={"my-file.csv"}
  className="btn btn-primary"
   onClick={() => {
    console.log("You click the link"); // 👍🏻 Your click handling logic
  }}
  asyncOnClick={true}
  onClick={(event, done) => {
    axios.post("/spy/user").then(() => {
      done(); // REQUIRED to invoke the logic of component
    });
    getUsers = (event, done) => {
    if(!this.state.loading) {
      this.setState({
        loading: true
      });
      axios.get("/api/users").then((userListJson) => {
        this.setState({
          listOfUsers: userListJson,
          loading: false
        });
        done(true); // Proceed and get data from dataFromListOfUsersState function
      }).catch(() => {
        this.setState({
          loading: false
        });
        done(false);
      });
    }
  }
 *  <Button
          color="primary"
          size="small"
          variant="text"
        >
          Download CSV <ArrowRightIcon />
        </Button>
 * align="right"Math.trunc(
 *                     <Box sx={{ margin: 1 }}>    </Table>
                    </Box>
 *      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>   </TableCell>
 *         <TableHead>
                            <TableRow>
                              <TableCell>Date</TableCell>
                              <TableCell>Customer</TableCell>
                              <TableCell align="right">Amount</TableCell>
                              <TableCell align="right">Total price ($)</TableCell>
                            </TableRow>
                          </TableHead>
 *                         <Typography variant="h6" gutterBottom component="div">
                          History
                        </Typography>
 *  <div className={classes.statusContainer}>
                        <StatusBullet
                          className={classes.status}
                          color={statusColors[order.status]}
                          size="sm"
                        />
                        {order.status}
                      </div>
                      <Button
            color="primary"
            size="small"
            variant="outlined"
          >
            Stock entry
          </Button>

                       <Button
                        color="primary"
                        variant="contained"
                        size="small"
                      //   onClick={() => { onClickDelete(item) }}
                      >
                        {"CLOSE"}
                      </Button>

                       <Link
                          component="button"
                          variant="body2"
                          onClick={() => {
                            console.info("I'm a button.");
                          }}
                        >
                          <PlusIcon style={{ "fontSize": "1rem" }} />
                        </Link>
 */
